import React from 'react';
import { Leaf } from 'lucide-react';
import { approach } from '../mock';

const Approach = () => {
  return (
    <section id="enfoque" className="py-24 lg:py-32 bg-[#E5EAE0] relative overflow-hidden">
      <div
        aria-hidden
        className="absolute -bottom-32 -left-20 w-[480px] h-[480px] rounded-full opacity-50 blur-3xl"
        style={{
          background:
            'radial-gradient(circle at 50% 50%, #C5D2BB 0%, #E5EAE0 60%, transparent 80%)',
        }}
      />

      <div className="max-w-[1400px] mx-auto px-6 lg:px-12 relative">
        <div className="max-w-[820px]">
          <div className="flex items-center gap-3 mb-6">
            <span className="divider-mark" />
            <span className="eyebrow">Mi enfoque</span>
          </div>
          <h2 className="font-serif text-[40px] lg:text-[60px] leading-[1.02] text-[#2E2A23] tracking-[-0.02em]">
            Una mirada
            <span className="italic text-[#B8806E]"> integral</span>, sensible y
            con herramientas concretas.
          </h2>
          <p className="mt-7 text-[16.5px] leading-[1.8] text-[#2E2A23]/80 max-w-[680px] font-light">
            Trabajo desde la teoría del apego, el enfoque sistémico familiar y
            con perspectiva de género. Considero fundamental comprender a cada
            persona dentro de su contexto: su historia, su entorno familiar,
            social y escolar. No patologizo — escucho, observo y acompaño
            procesos desde el respeto.
          </p>
        </div>

        <div className="mt-14 grid sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {approach.map((a, idx) => (
            <div
              key={a.title}
              className="group relative bg-[#F1F4ED] border border-[#C5D2BB] rounded-2xl p-7 hover:border-[#8FA08A] transition-all duration-500"
            >
              <div className="flex items-center justify-between mb-6">
                <span className="w-11 h-11 rounded-full bg-[#DAE2D2] grid place-items-center text-[#5F7259] border border-[#B8C8AD]">
                  <Leaf size={18} strokeWidth={1.5} />
                </span>
                <span className="font-serif text-[#A4B19D] text-[28px] italic">
                  0{idx + 1}
                </span>
              </div>
              <h3 className="font-serif text-[24px] text-[#2E2A23] leading-tight">
                {a.title}
              </h3>
              <p className="mt-3 text-[14.5px] leading-[1.7] text-[#2E2A23]/75">
                {a.body}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Approach;
